/*
 * @description:
 * @param :
 * @return:
 */
// import storage from 'store'
const getters = {
  isMobile: state => state.app.isMobile,
  lang: state => state.app.lang,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  account: state => state.user.account,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  params: state => {
    return {
      user_id: state.user.info.uid,
      // storage.get('UserInfo').uid,
      token: state.user.info.token,
      agent_token: state.user.account.Token,
      bd_no: state.user.account.UniqueId,
      appid: '2017042406924805',
      appname: '满意付',
      operator_id: state.user.account.Id,
      operator_token: state.user.account.Token,
      operator_role: state.user.account.Role,
      MerchantUid: state.user.account.MerchantUid
    }
  }
}

export default getters
